/**
 * A implementação dos serializadores foi baseada em:
 * http://mcculloughwebservices.com/2016/09/23/handling-a-null-response-from-an-api/
 *
 * Não é possível simplesmente realizar a chamada de response.json()
 * pois decidimos que a nossa API poderia retornar valores com o Body
 * vazio e/ou nulo, sendo assim, ocorreria um erro ao deserializar
 * que é resolvido com a implementação adotada
 */
import serverURL from './serverURL'
import fetchConfig from './fetchConfig'
import STATUS_CODE from './statusCode'
import store from '../createStore'
import * as actions from 'actions/index'
import { addBreadcrumb, sanitizePath } from '../../support/breadcrumbs'

// What support needs to find a failed request: the status and the server's ids for it.
// Read once here so every error the app shows can carry them (src/utils/userError.js).
function readHeader(response, name) {
  try {
    return (response && response.headers && typeof response.headers.get === 'function' &&
      response.headers.get(name)) || undefined
  } catch (e) {
    return undefined
  }
}

export function attachResponseEvidence(target, response) {
  if (!target || typeof target !== 'object' || !response) {
    return target
  }
  // responseStatus, not status: a validation body may carry its own status field.
  if (target.responseStatus === undefined) {
    target.responseStatus = response.status
  }
  const correlationId = readHeader(response, 'X-Correlation-ID')
  const supportReference = readHeader(response, 'X-Support-Reference')
  if (correlationId && !target.responseCorrelationId) {
    target.responseCorrelationId = correlationId
  }
  if (supportReference && !target.supportReferenceHeader) {
    target.supportReferenceHeader = supportReference
  }
  return target
}

function throwValidationErrors(response) {
  return response.json().then(errors => {
    throw attachResponseEvidence(errors, response)
  })
}

function parseErrorBody(response) {
  return response.text().then(text => {
    if (!text) {
      return {}
    }
    try {
      return JSON.parse(text)
    } catch (error) {
      return { message: text }
    }
  })
}

function throwUnexpectedError(response, errorMessage, errorCode) {
  return parseErrorBody(response).then(data => {
    const error = new Error(errorMessage)
    error.response = response
    error.data = data
    error.code = (data && typeof data === 'object' && data.code) || errorCode
    attachResponseEvidence(error, response)
    throw error
  })
}

function throwNetworkError(cause) {
  const error = new Error('We could not reach the service.')
  error.code = 'NETWORK_ERROR'
  error.isNetworkError = true
  // Offline and "server not reachable" need different next steps.
  error.offline = typeof navigator !== 'undefined' && navigator.onLine === false
  error.isTimeout = !!(cause && (cause.name === 'AbortError' || cause.name === 'TimeoutError'))
  error.cause = cause
  throw error
}

function _parseJSON(response) {
  return response.text().then(function (text) {
    return !!text ? JSON.parse(text) : {}
  })
}

// function _parseImagem(response) {
  
//   let data;
//   const urlCreator = window.URL || window.webkitURL;
//   return response.blob().then(blobResponse => {
//     data = blobResponse;
//     return urlCreator.createObjectURL(data);
//   })
// }

export default (path, config, headers, autoHandle = true, autoControlSpinner = true) => {

  if (!!autoControlSpinner) {
    store.dispatch(actions.startRequest())
  }
  return fetch(serverURL.api(path), fetchConfig(config, headers)).then(
    response => {
      if (!!autoControlSpinner) {
        store.dispatch(actions.finishRequest())
      }
      if (!response.ok) {
        addBreadcrumb('api_error', `${(config && config.method) || 'GET'} ${sanitizePath(path)}`, String(response.status))
      }
      if (response.ok) {
        // var res = response.url.startsWith("http://api-staging.lunch.team/menu/v1/image/restaurant/cover") ||
        //   response.url.startsWith("https://api.lunch.team/menu/v1/image/restaurant/cover") ?
        //   _parseImagem(response) : _parseJSON(response);

        var res =_parseJSON(response);

        return res;
      } else if (STATUS_CODE.isAuthenticationError(response)) {
        store.dispatch(actions.logoutSuccess())
        // - enviar para a rota de login com mensagem
        // avisando que session expirou
        // - excluir informações localStorage
        return throwUnexpectedError(
          response,
          'Your session has expired. Please sign in again.',
          'AUTHENTICATION_REQUIRED'
        )
      } else if (!autoHandle) {
        return response
      } else if (STATUS_CODE.isValidationError(response)) {
        // tratar genericamente
        // lançar erro
        return throwValidationErrors(response)
      } else {
        // exibir erro
        // lançar erro
        return throwUnexpectedError(
          response,
          "Lunch.Team couldn't finish that request.",
          'HTTP_ERROR'
        )
      }
    }
    , error => {
      store.dispatch(actions.finishRequest())
      addBreadcrumb('api_error', `${(config && config.method) || 'GET'} ${sanitizePath(path)}`, 'network')
      throwNetworkError(error)
    }
  )
}



// WEBPACK FOOTER //
// ./src/config/fetch/fetch.js